import * as types from './action-types'

export const idleLightbox = idle => ({
  type: types.LIGHTBOX_IDLE,
  payload: idle
})

export const mediaTypeLightbox = mediaType => ({
  type: types.LIGHTBOX_MEDIA_TYPE,
  payload: mediaType
})



// WEBPACK FOOTER //
// ./src/components/lightbox-container/actions.js